import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useMutation } = ReactQueryV5;
import type { Psychologist, PsychologistProfile } from "core/types";
import { formatPsychologistModel } from "../models/psychologist";
import { put } from "../services/httpClient";

type CreatePsychologistResponse = {
  data: Psychologist;
  info: { code: number };
};

const createPsychologist = (psychologist: PsychologistProfile) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { psychologistId, slots, ...payload } = formatPsychologistModel(
    psychologist as Partial<Psychologist>,
  );
  return put<CreatePsychologistResponse, typeof payload>(
    "psychologist",
    payload,
  ).then((res) => {
    if (
      res.info.code === 500 ||
      (res && res.data && !res.data.psychologistId)
    ) {
      throw res.info;
    }
    return res;
  });
};

export const useCreatePsychologist = () =>
  useMutation({ mutationFn: createPsychologist });

type ChangeTitlePayload = { slotId: number; slotTitle: string };

const changeTitle = (payload: ChangeTitlePayload) =>
  put<unknown, ChangeTitlePayload>("psychologist/calendar/slottitle", payload);

export const useChangeTitle = () => useMutation({ mutationFn: changeTitle });
